import React, { useState, useEffect, useMemo } from 'react'
import { bindActionCreators } from '@reduxjs/toolkit'
import { connect } from 'react-redux'
import * as UserActions from '../reducers/user'
import * as ConfigActions from '../reducers/config'
import * as BotProfileActions from '../reducers/botProfile'
import * as BotProfilesActions from '../reducers/botProfiles'
import UserProfileDetails from './ProfileSetup/UserProfileDetails';
// import * as QuestionnaireActions from '../reducers/slices/questionnaire'
import CustomTheme from '../components/CustomTheme'
import {
    Grid,
    Typography,
    Drawer,
    Toolbar,
    Divider,
    Box,
    Stack,
    CssBaseline,
    List,
    ListItem,
    Snackbar
} from '@mui/material'
import methods from '../reducers/methods'
import botImgObj from './ChatRoom'
import DemoProfile from './ProfileSetup/DemographicProfile'
import LifeDetails from './ProfileSetup/LifeDetails'
import HealthData from './ProfileSetup/HealthData'
import config from '../config/config'
import { Redirect, Route, useRouteMatch } from 'react-router-dom'
import { withRouter } from "react-router"
import {
    IonApp,
    IonPage,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    setupIonicReact,
    IonContent
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router'
import BotHelper from '../helpers/BotHelper'
import UserProfileHelper from '../helpers/UserProfileHelper'
import AuthenticationHelper from '../helpers/AuthenticationHelper'
import LeftProgressPanel from './ProfileSetup/LeftProgressPanel'
import { defaultLang } from '../lang/init'

const basicLoginKeys = []
const routes = {
    0: "/profilesetup/user-profile",
    1: "/profilesetup/demo-profile",
    2: "/profilesetup/life-details",
    3: "/profilesetup/health-data",
    4: "/profilesetup/summary",
};

class ProfileSetup extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            entries: {},
            incomplete: [],
            isLoaded: false,
            errorMessage: "",
            successMessage: "",
            isSubmitting: false,
            crowdId: "",
            targetSurveyId: 1,
            defaultBots: [],
            selectedDot: 0,
            snackbarOpen: false,
            snackbarMessage: ""
        }

        // this.handleInputChange = this.handleInputChange.bind(this)
        this.saveTimer = null;
        this.openSnackbar = this.openSnackbar.bind(this)
        this.closeSnackbar = this.closeSnackbar.bind(this)
        this.handleSurveyTemporaryStoring = this.handleSurveyTemporaryStoring.bind(this)
        this.handleSubmitSurvey = this.handleSubmitSurvey.bind(this)
        this.handleRedirectToBot = this.handleRedirectToBot.bind(this)
        this.handleDotSelected = this.handleDotSelected.bind(this)
    }

    async componentDidMount() {
        const { config, user, login, switchLanguage, resetSession, botProfile } = this.props
        const { dict, lang } = config
        
        console.log("the bot profile received is ", botProfile)

        // better the load the language every time logging into the app
        switchLanguage(defaultLang)

        this.setState({ isLoaded: false })
        // console.log(match)

        // first load all the default bot profiles to choose
        const { bot, botProfiles, loadProfile } = this.props
        let defaultBots = []
        // console.log("personal bot profile", bot)
        // console.log("all the bot profiles", botProfiles)
        Object.keys(botProfiles).map((k, idx) => {
            const targetBotObj = botProfiles[k]
            // console.log("to be filled bot profile",targetBotObj)
            let newBotObj = {
                id: targetBotObj["id"],
                profileObj: {
                    name: targetBotObj["name"],
                    age: targetBotObj["age"],
                    condition: targetBotObj["condition"],
                    story: targetBotObj["story"],
                    background: targetBotObj["background"],
                    personality: targetBotObj["personalityObj"],
                    symptomsAndBehaviours: targetBotObj["symptomsAndBehavioursObj"],
                    responseStyle: targetBotObj["responseStyleObj"]
                }
            }
            defaultBots.push(newBotObj)
        })

        this.setState({
            isLoaded: true,
            defaultBots,
            snackbarMessage: dict["setupProfile"]["general"]["snackbarMsg"]
        })
    }
    openSnackbar = () => {
        // console.log('open snackbar called')
        this.setState({ snackbarOpen: true })
    }
    closeSnackbar = () => this.setState({ snackbarOpen: false })

    componentDidUpdate(prevProps) {
        // if bot changed and no timer is pending, schedule a save in 5s
        if (prevProps.bot !== this.props.bot) {
            // console.log("bot should be updated and saved", this.saveTimer)
            // console.log("bot is updated, timer:", this.saveTimer);
            if (!this.saveTimer) {
                this.saveTimer = setTimeout(() => {
                    // console.log("timeout triggered, saving…");
                    this.handleSurveyTemporaryStoring();
                    // clear the handle so future changes can schedule again
                    this.saveTimer = null;
                }, 10000);
            }
        }
    }

    componentWillUnmount() {
        // clean up if component unmounts
        if (this.saveTimer) {
            clearTimeout(this.saveTimer);
        }
    }
    async handleSurveyTemporaryStoring() {
        const { bot, user, botProfile } = this.props
        try{
            let testProfile = {
                name: bot["profileObj"]["name"] ?? "",
                age: bot["profileObj"]["age"] ?? 0,
                gender: bot["profileObj"]["gender"] ?? "",
                story: bot["profileObj"].hasOwnProperty("storyObj") ? BotHelper.convertJsonToYmlString(bot["profileObj"]["storyObj"]) : "",
                background: bot["profileObj"].hasOwnProperty("backgroundObj") ? BotHelper.convertJsonToYmlString(bot["profileObj"]["backgroundObj"]) : "",
                personality: bot["profileObj"].hasOwnProperty("personalityObj") ? BotHelper.convertJsonToYmlString(bot["profileObj"]["personalityObj"]) : "",
                symptomsAndBehaviours: bot["profileObj"].hasOwnProperty("symptomsAndBehavioursObj") ? BotHelper.convertJsonToYmlString(bot["profileObj"]["symptomsAndBehavioursObj"]) : "",
                responseStyle: bot["profileObj"].hasOwnProperty("responseStyleObj") ? BotHelper.convertJsonToYmlString(bot["profileObj"]["responseStyleObj"]) : "",
                shortMem: "",
                // longMem: bot["profileObj"]["longMem"] ?? ""
            }
            // when it's saving, the longMem should be an object
            if(bot["profileObj"].hasOwnProperty("longMem") && typeof bot["profileObj"]["longMem"] !== "string" && bot["profileObj"]["longMem"] !== "" )
            {
                // console.log("profile object's long mem is detected ", BotHelper.convertObjectToLongMemYaml(bot["profileObj"]["longMem"]))
                testProfile["longMem"] = BotHelper.convertObjectToLongMemYaml(bot["profileObj"]["longMem"])
            }
            else
            {
                testProfile["longMem"] = ""
            }
            if (botProfile.hasOwnProperty("id") && botProfile.id !== "" && botProfile.id !== null && botProfile.id !== undefined) {
                // testProfile["id"] = botProfile.id
                const response = await BotHelper.updateBotProfile(botProfile.id, testProfile)
                if (response.status === "success") {
                    // console.log("response", response)
                    await this.openSnackbar();
                    return true
                }
                return false
            }
            const response = await BotHelper.addBotProfile(testProfile);
            // console.log("added bot", response)
            if (response.status === "success") {
                // await this.loadAllBotProfiles();  // Reload profiles after adding
                // console.log("the saving is successful", response);

                if (response.hasOwnProperty("addedData")) {
                    let newBotId = response["addedData"]["id"];

                    // === 2025/07/04 change strategy. A user is only allowed 1 bot. ===//
                    // Make sure to load user's existing bots first
                    // let existingBots = Array.isArray(user.bots_owned) ? [...user.bots_owned] : [];
                    // console.log("existing bots before update ", existingBots);
                    // existingBots.push(newBotId);
                    // === 2025/07/04 change strategy. A user is only allowed 1 bot. ===//

                    let existingBots = [newBotId]
                    // console.log("existing bots after update ", existingBots);

                    // Update user profile to add bot id
                    const updateData = {
                        recent_activities: "BOT_CREATING_IN_PROGRESS",
                        bots_owned: existingBots 
                    };

                    // Use a different variable name for the second API call response
                    const updateResponse = await UserProfileHelper.updateUserProfile(AuthenticationHelper.uuid, updateData);
                    // console.log("update user profile", updateResponse);

                    await this.openSnackbar();

                    return true
                }
            }
            return false;
        }
        catch(e){
            console.log("temporary saving failed", e)
        }
    }

    async handleSubmitSurvey() {
        // if you want to determine which user owns the bot, you need to get the user session first
        // IMPORTANT! To save the bot, don't add ID, or else it will overwrite the existing data
        const { bot, user, botProfile } = this.props
        try {
            let testProfile = {
                name: bot["profileObj"]["name"],
                age: bot["profileObj"]["age"],
                gender: bot["profileObj"]["gender"],
                story: bot["profileObj"]["story"],
                background: bot["profileObj"]["background"],
                personality: bot["profileObj"]["personality"],
                symptomsAndBehaviours: bot["profileObj"]["symptomsAndBehaviours"],
                responseStyle: bot["profileObj"]["responseStyle"],
                shortMem: "",
                // longMem: bot["profileObj"]["longMem"]
            }
            if(bot["profileObj"].hasOwnProperty("longMem") && typeof bot["profileObj"]["longMem"] !== "string" && bot["profileObj"]["longMem"] !== "" )
            {
                testProfile["longMem"] = BotHelper.convertObjectToLongMemYaml(bot["profileObj"]["longMem"])
            }
            else if(typeof bot["profileObj"]["longMem"] === "string" &&bot["profileObj"]["longMem"] !== "")
            {
                testProfile["longMem"] = bot["profileObj"]["longMem"]
            }
            else
            {
                testProfile["longMem"] = ""
            }
            // console.log("the test profile is ", testProfile)
            // console.log("the long mem is ",bot["profileObj"]["longMem"])
            // if user enters into the edit mode
            if (botProfile.hasOwnProperty("id") && botProfile.id !== "" && botProfile.id !== null && botProfile.id !== undefined) {
                // testProfile["id"] = botProfile.id
                const response = await BotHelper.updateBotProfile(botProfile.id, testProfile)
                if (response.status === "success") {
                    const updateData = {
                        recent_activities: "BOT_CREATED"
                    };

                    // Use a different variable name for the second API call response
                    const updateResponse = await UserProfileHelper.updateUserProfile(AuthenticationHelper.uuid, updateData);
                    // console.log("response", response)
                    return true
                }
                return false
            }
            const response = await BotHelper.addBotProfile(testProfile);
            // console.log("added bot", response)
            if (response.status === "success") {
                // await this.loadAllBotProfiles();  // Reload profiles after adding
                // console.log("the saving is successful", response);

                if (response.hasOwnProperty("addedData")) {
                    let newBotId = response["addedData"]["id"];

                    // === 2025/07/04 change strategy. A user is only allowed 1 bot. ===//
                    // Make sure to load user's existing bots first
                    // let existingBots = Array.isArray(user.bots_owned) ? [...user.bots_owned] : [];
                    // console.log("existing bots before update ", existingBots);
                    // existingBots.push(newBotId);
                    // === 2025/07/04 change strategy. A user is only allowed 1 bot. ===//

                    let existingBots = [newBotId]
                    // console.log("existing bots after update ", existingBots);

                    // Update user profile to add bot id
                    const updateData = {
                        recent_activities: "BOT_CREATED",
                        bots_owned: existingBots 
                    };

                    // Use a different variable name for the second API call response
                    const updateResponse = await UserProfileHelper.updateUserProfile(AuthenticationHelper.uuid, updateData);
                    // console.log("update user profile", updateResponse);

                    return true
                }
            }
            return false;
        } catch (e) {
            console.error("Error during bot update:", e);
            return false;
        }

    }
    // after user has created the first bot, should immediately load the bot and redirect to the chatroom
    async handleRedirectToBot() {

        const { history } = this.props
        return setTimeout(() => {
            history.push("/chatroom/pdfbot")
        }, 5000)
    }

    async handleDotSelected(idx) {
        if (this.state.selectedDot === idx) return;
        const { history } = this.props;
        this.setState({ selectedDot: idx });
        history.push(routes[idx] || routes[0]); // 默认跳转到第0步

        switch (idx) {
            case 3:
                this.setState({
                    selectedDot: 3
                })
                history.push("/profilesetup/health-data")
                return
            // break
            case 2:
                this.setState({
                    selectedDot: 2
                })
                history.push("/profilesetup/life-details")
                return
            // break
            case 1:

                this.setState({
                    selectedDot: 1
                })
                history.push("/profilesetup/demo-profile")
                return
            // break
            case 0:
            default:
                this.setState({
                    selectedDot: 0
                })
                history.push("/profilesetup/user-profile")
                return
        }
    }

    render() {
        const { 
            history, 
            loadProfile, 
            botprofiles, 
            bot, 
            updateBotProfile, 
            updateBotProfileBulk, 
            } = this.props
        const { defaultBots } = this.state
        const { config, user, login, switchLanguage, resetSession } = this.props
        const { dict, lang } = config

        // console.log("dict", dict)
        return (<CustomTheme>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={this.state.snackbarOpen}
                message={this.state.snackbarMessage}
                autoHideDuration={3000}
                onClose={this.closeSnackbar}
            />
            <IonRouterOutlet>
                <Route exact path="/profilesetup">
                    <Redirect to="/profilesetup/user-profile" />
                </Route>
                {/* Redirect from /profilesetup to /profilesetup/demo-profile */}
                <Route path="/profilesetup/user-profile">
                    <IonPage>
                    <UserProfileDetails
                        resetSession={resetSession}
                        history={history}
                        defaultBots={defaultBots}
                        botprofiles={botprofiles}
                        loadProfile={loadProfile}
                        bot={bot}
                        updateBotProfile={updateBotProfile}
                        updateBotProfileBulk={updateBotProfileBulk}
                        selectedDot={this.state.selectedDot}
                        setSelectedDot={idx => this.handleDotSelected(idx)}
                        dict={dict["setupProfile"]["user"]}
                        progressSave={this.handleSurveyTemporaryStoring}
                    >
                        <LeftProgressPanel dict={dict["setupProfile"]["leftPanel"]} history={history} selectedDot={this.state.selectedDot} setSelectedDot={idx => this.handleDotSelected(idx)} />
                    </UserProfileDetails>
                    </IonPage>
                </Route>


                {/* Subpage Routes */}
                <Route path="/profilesetup/demo-profile">
                    <IonPage>
                    <DemoProfile
                        resetSession={resetSession}
                        history={history}
                        defaultBots={defaultBots}
                        botprofiles={botprofiles}
                        loadProfile={loadProfile}
                        bot={bot}
                        updateBotProfile={updateBotProfile}
                        updateBotProfileBulk={updateBotProfileBulk}
                        selectedDot={this.state.selectedDot}
                        setSelectedDot={idx => this.handleDotSelected(idx)}
                        dict={dict["setupProfile"]["demo"]}
                        progressSave={this.handleSurveyTemporaryStoring}
                    >
                        <LeftProgressPanel dict={dict["setupProfile"]["leftPanel"]} history={history} selectedDot={this.state.selectedDot} setSelectedDot={idx => this.handleDotSelected(idx)} />
                    </DemoProfile>
                    </IonPage>
                </Route>
                <Route path="/profilesetup/life-details">
                    <IonPage>
                    <LifeDetails
                        resetSession={resetSession}
                        history={history}
                        loadProfile={loadProfile}
                        bot={bot}
                        updateBotProfile={updateBotProfile}
                        updateBotProfileBulk={updateBotProfileBulk}
                        selectedDot={this.state.selectedDot}
                        setSelectedDot={idx => this.handleDotSelected(idx)}
                        dict={dict["setupProfile"]["life"]}
                        progressSave={this.handleSurveyTemporaryStoring}
                    >
                        <LeftProgressPanel dict={dict["setupProfile"]["leftPanel"]} history={history} selectedDot={this.state.selectedDot} setSelectedDot={idx => this.handleDotSelected(idx)} />
                    </LifeDetails>
                    </IonPage>
                </Route>
                <Route path="/profilesetup/health-data">
                    <IonPage>
                    <HealthData
                        resetSession={resetSession}
                        history={history}
                        defaultBots={defaultBots}
                        bot={bot}
                        updateBotProfile={updateBotProfile}
                        updateBotProfileBulk={updateBotProfileBulk}
                        selectedDot={this.state.selectedDot}
                        setSelectedDot={idx => this.handleDotSelected(idx)}
                        handleSubmitSurvey={this.handleSubmitSurvey}
                        handleRedirectToBot={this.handleRedirectToBot}
                        dict={dict["setupProfile"]["health"]}
                        progressSave={this.handleSurveyTemporaryStoring}
                    >
                        <LeftProgressPanel dict={dict["setupProfile"]["leftPanel"]} history={history} selectedDot={this.state.selectedDot} setSelectedDot={idx => this.handleDotSelected(idx)} />
                    </HealthData>
                    </IonPage>
                </Route>
            </IonRouterOutlet>
        </CustomTheme>)
    }
}

let ProfileSetupContainer = props => {
    // const { dispatch, questionnaire, user, config } = props
    const { user, config, botProfile, botProfiles, dispatch } = props

    const boundUserActionCreators = useMemo(() => bindActionCreators({
        ...UserActions,
        ...ConfigActions,
        ...BotProfileActions,
        ...BotProfilesActions,
        // ...QuestionnaireActions,
        resetSession: methods.RESET_SESSION_ACTION
    }, dispatch), [dispatch])
    // const bountConfigActionCreators = useMemo(() => bindActionCreators(ConfigActions, dispatch), [dispatch])

    // console.log("home container props", bountUserActionCreators)
    return <ProfileSetup
        user={user}
        config={config}
        bot={botProfile}
        botprofiles={botProfiles}
        // questionnaire={questionnaire}
        {...boundUserActionCreators} {...props} />
}

// SurveyContainer = connect(state => ({ ...state.questionnaireReducer, config: state.configReducer, user: state.userReducer }))(SurveyContainer)
ProfileSetupContainer = connect(state => ({
    config: state.config,
    user: state.user,
    botProfile: state.botProfile,      // Access botprofile from the correct slice of state
    botProfiles: state.botProfiles,     // Access botprofiles from the correct slice of state
    resetSession: methods.RESET_SESSION
}))(ProfileSetupContainer)

export default withRouter(ProfileSetupContainer)